import { gql } from '@apollo/client';

export const getLatestProposalList = gql`
  query getLatestProposalList(
    $pagination: PaginationInput!
    $selectedLines: [String]
    $selectedSublines: [String]
    $selectedPlans: [String]
    $selectedBusinessPartners: [String]
    $SelectedStatuses: [Production_ProposalStatuses]
    $selectedStatusReasons: [String]
    $FromCreatedOn: Date
    $ToCreatedOn: Date
    $FromEffectiveOn: Date
    $ToEffectiveOn: Date
    $selectedInsuredIDs: [String]
    $KeywordSearch: String
    $OrderBy: Core_OrderBy
  ) {
    Production {
      queries {
        getLatestProposalList(
          KeywordSearch: $KeywordSearch
          OrderBy: $OrderBy
          pagination: $pagination
          selectedStatuses: $SelectedStatuses
          selectedStatusReasons: $selectedStatusReasons
          selectedLines: $selectedLines
          selectedSublines: $selectedSublines
          selectedPlans: $selectedPlans
          selectedBusinessPartners: $selectedBusinessPartners
          FromCreatedOn: $FromCreatedOn
          ToCreatedOn: $ToCreatedOn
          FromPolicyEffectiveDate: $FromEffectiveOn
          ToPolicyEffectiveDate: $ToEffectiveOn
          selectedInsuredIDs: $selectedInsuredIDs
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            production_Proposal_Id
            production_Proposal_ProposalName
            production_Proposal_InternalCode
            production_Proposal_PolicyEffectiveDate
            production_Proposal_PolicyExpiryDate
            production_Proposal_Status
            production_Proposal_StatusReason
            production_Proposal_MotorDetailsID {
              id
              views {
                Production_all {
                  properties {
                    NameOnLicenseEn
                    NameOnLicenseAr
                  }
                }
              }
            }
            production_Proposal_PrimaryBPID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                  }
                }
              }
            }
            production_Proposal_InsuredID {
              id
              views {
                Production_all {
                  properties {
                    PersonCode
                    FullName
                  }
                }
              }
            }
            production_Proposal_createdOn
            production_Proposal_modifiedOn
            line_Id
            line_Name
            line_ExternalCode
            production_Proposal_LineID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                  }
                }
              }
            }
            production_Proposal_SublineID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                  }
                }
              }
            }
            production_Proposal_PlanID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                  }
                }
              }
            }
            production_Proposal_BusinessUserID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Account
                  }
                }
              }
            }
            production_Proposal_PolicyBPID {
              id
            }
          }
        }
      }
    }
  }
`;

export const getBPPlanListQuery = gql`
  query getBPPlanListQuery(
    $selectedBusinessUserID: String!
    $selectedLineID: [String]
    $selectedPlanID: [String]
  ) {
    SalesforceManagement {
      queries {
        getDistinctAssignedBPLineListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
          selectedLineID: $selectedLineID
          selectedPlanID: $selectedPlanID
        ) {
          salesforceManagement_AssignedBPPlan_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Id
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
        getDistinctAssignedBPPlanListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
          selectedLineID: $selectedLineID
          selectedPlanID: $selectedPlanID
        ) {
          salesforceManagement_AssignedBPPlan_PlanID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                  ExternalCode
                  SublineID {
                    id
                    views {
                      PlanConfigManagement_all {
                        properties {
                          Name
                          ExternalCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getStaticLovsQuery = gql`
  query GetStaticLovs {
    Production {
      lookups {
        proposalStatusReasons {
          Id
          Title
        }
      }
    }
    Production_ProposalStatuses: __type(name: "Production_ProposalStatuses") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getAssignedPersonsQuery = gql`
  query GetAssignedPersonsWithPagination(
    $selectedBusinessPartners: [String]
    $pagination: PaginationInput!
    $searchKeyword: String
  ) {
    Production {
      queries {
        GetAssignedPersonsWithPagination(
          selectedBusinessPartners: $selectedBusinessPartners
          pagination: $pagination
          searchKeyword: $searchKeyword
          selectedType: INSURED
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            salesforceManagement_AssignedPerson_PersonID {
              id
            }
            salesforceManagement_AssignedPerson_FullName
            salesforceManagement_AssignedPerson_PersonCode
          }
        }
      }
    }
  }
`;

export const getAssignedBusinessPartnersQuery = gql`
  query getAssignedBusinessPartnersQuery(
    $selectedBusinessUserID: String!
    $searchKeyword: String
    $pagination: PaginationInput!
  ) {
    SalesforceManagement {
      queries {
        getAssignedBPList(
          selectedBusinessUserID: $selectedBusinessUserID
          status: ACTIVE
          keywordSearch: $searchKeyword
          pagination: $pagination
        ) {
          paging {
            pageNumber
            pageSize
            totalCount
          }
          items {
            salesforceManagement_AssignedBP_Id
            businessPartner_Id
            businessPartner_PersonID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    FullName
                  }
                }
              }
            }
            salesforceManagement_AssignedBP_BusinessUserID {
              id
            }
            salesforceManagement_AssignedBP_BusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                    PersonID {
                      id
                      views {
                        SalesforceManagement_all {
                          properties {
                            FullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
